import { render, staticRenderFns } from "./HighlevelConcept.vue?vue&type=template&id=87fd9a66&"
import script from "./HighlevelConcept.vue?vue&type=script&lang=ts&"
export * from "./HighlevelConcept.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports